var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Form } from 'formik';
import Typography from '@mui/material/Typography';
import { Spacer } from '../../../../uikit/misc/Spacer';
import { getTranslation } from '../../../../utils/translations';
import { RadioGroupFormikField as RadioGroup } from '../../../../components/molecules/FormFields/RadioGroupField';
import { SelectFormikField as Select } from '../../../../components/molecules/FormFields/SelectField';
import { FormikForm } from '../../../../components/molecules/FormikForm';
import { mainFormSlice } from '../../../../store/mainForm/mainForm.slice';
import { applicantPageModel } from './formModel';
import translation from './translations';
import constants from './constants';
import { Dangerous } from '../../../../utils/dangerous';
import { ApplicantSubform } from './ApplicantSubform';
import { MAIN_FORM_STEPS } from '../../../../store/mainForm/mainForm.types';
import { ProgressiveDisclosure } from '../../../../components/molecules/ProgressiveDisclosure';
import { ABTestSlice } from '../../../../store/ABTest/ABTest.slice';
import { APPLICANT_PAGE__POINT_TO_SCROLL_ID } from '../../config';
import { MainFormFooter } from '../../../../components/molecules/MainFormFooter';
var applicantsCountOptions = constants.applicantsCountOptions, isSameHouseholdOptions = constants.isSameHouseholdOptions;
var t = getTranslation(translation);
var validationSchema = applicantPageModel.validationSchema, paths = applicantPageModel.paths, SELECTORS = applicantPageModel.selectors;
var mapStateToProps = function (state) { return ({
    initialValues: mainFormSlice.selectors.getApplicantData(state),
    isAbleToProceed: mainFormSlice.selectors.getIsAbleToProceed(state),
    isProgressiveDisclosureEnabled: ABTestSlice.selectors.isProgressiveDisclosureEnabled(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    saveApplicantState: function (values) {
        return dispatch(mainFormSlice.actions.saveApplicantData(values));
    },
    goToNextPage: function () {
        dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.PROJECT_PAGE));
    },
}); };
export var RawApplicantPage = function (props) {
    var initialValues = props.initialValues, isAbleToProceed = props.isAbleToProceed, isProgressiveDisclosureEnabled = props.isProgressiveDisclosureEnabled, goToNextPage = props.goToNextPage, saveApplicantState = props.saveApplicantState;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h3", id: APPLICANT_PAGE__POINT_TO_SCROLL_ID }, t.title),
        React.createElement(Spacer, { size: 3 }),
        React.createElement(FormikForm, { initialValues: initialValues, validationSchema: validationSchema, validateOnChange: false, onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, saveApplicantState(values)];
                        case 1:
                            _a.sent();
                            actions.setSubmitting(false);
                            goToNextPage();
                            return [2 /*return*/];
                    }
                });
            }); } }, function (formik) {
            var _a = formik.values.applicantsCount, applicantsCount = _a === void 0 ? 1 : _a;
            useEffect(function () {
                // SUI Select can't emit undefined as value
                var selectedValue = SELECTORS.MARITAL_STATUS(formik.values);
                if (selectedValue === t.maritalStatus_no_value) {
                    formik.setFieldValue(paths.MARITAL_STATUS, undefined);
                }
            }, [SELECTORS.MARITAL_STATUS(formik.values)]);
            return (React.createElement(Form, null,
                React.createElement(ApplicantSubform, { namespace: paths.APPLICANT, applicantsCount: applicantsCount, isProgressiveDisclosureEnabled: isProgressiveDisclosureEnabled }),
                React.createElement(ProgressiveDisclosure, { dependOnPath: paths.APPLICANT_PHONE, isEnabled: isProgressiveDisclosureEnabled },
                    React.createElement(Spacer, { size: 3 }),
                    React.createElement(RadioGroup, { name: paths.APPLICANTS_COUNT, label: t.numberOfApplicants, description: t.numberOfApplicantsDescription, options: applicantsCountOptions, colProps: { xs: 12, sm: 6 } }),
                    applicantsCount === 2 && (React.createElement(React.Fragment, null,
                        React.createElement(ApplicantSubform, { namespace: paths.SECOND_APPLICANT, applicantsCount: applicantsCount, isSecondApplicant: true }),
                        React.createElement(RadioGroup, { name: paths.IS_SAME_HOUSEHOLD, label: t.secondApplicantQuestion, options: isSameHouseholdOptions }),
                        React.createElement(Select, { name: paths.MARITAL_STATUS, label: t.maritalStatusLabel, options: constants.maritalStatusOptions })))),
                React.createElement(Spacer, { size: 3 }),
                React.createElement(ProgressiveDisclosure, { dependOnPath: paths.APPLICANT_PHONE, isEnabled: isProgressiveDisclosureEnabled },
                    React.createElement(Typography, { variant: "body1" },
                        React.createElement(Dangerous, { html: t.policiesDescriptionHTML })),
                    React.createElement(Spacer, { size: 2 })),
                React.createElement(MainFormFooter, { isBackwardVisible: false, isForwardDisabled: formik.isSubmitting || !isAbleToProceed }),
                React.createElement(Typography, { variant: "hint" }, t.subscriptionPoliciesText)));
        }),
        React.createElement(Spacer, { size: 3 })));
};
export var ApplicantPage = connect(mapStateToProps, mapDispatchToProps)(RawApplicantPage);
